export const BRAND = {
  name: "AthenaCrest Defense",
  founder: "Sierra Thomas",
  founderCredentials: "MJ, Health Law & Compliance Studies",
  logoUrl: "/images/logo.png",
  calendlyUrl: "https://calendly.com/sierrathomas85/30min",
  email: "sierra@athenacrestdefense.com",
  phone: "(618) 750-0235",
  linkedin: "https://www.linkedin.com/in/sierra-thomas-athenacrest",
  tagline: "Protect the Facility. Restore Compliance. Recover Revenue.",
};

export const MEDIA = {
  heroBg: "/images/hero-bg.jpg",
  texture:
    "https://static.prod-images.emergentagent.com/jobs/b8c70e45-bc4a-409b-a628-775d2942cdfe/images/48acfeb47edc6ae2c982cc10593528a4cefd0d1de89c414c6c50a9e09a36a79a.png",
  corporateOffice: "/images/corporate-office.jpg",
  sierraThomas: "/images/sierra.jpg",
  hospitalHallway:
    "https://images.pexels.com/photos/37036967/pexels-photo-37036967.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Sierra" },
  { to: "/services", label: "Services" },
  { to: "/inservices-training", label: "Inservices & Training" },
  { to: "/medicaid-ar-recovery", label: "Medicaid & AR" },
  { to: "/survey-readiness", label: "Survey Readiness" },
  { to: "/operational-risk", label: "Operational Risk" },
  { to: "/litigation-support", label: "Litigation Support" },
  { to: "/speaking-training", label: "Speaking" },
  { to: "/knowledge-center", label: "Knowledge Center" },
  { to: "/contact", label: "Contact" },
];
